export function toPromise(request) {
    return new Promise((resolve, reject) => {
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}
export function committed(transaction) {
    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => resolve();
        transaction.onerror = () => reject(transaction.error);
        transaction.onabort = () => reject(transaction.error);
    });
}
export async function readAll(db, storeName) {
    if (!db.objectStoreNames.contains(storeName))
        return [];
    const transaction = db.transaction([storeName], 'readonly');
    return (await toPromise(transaction.objectStore(storeName).getAll()));
}
